import { useSessionContext } from '../../../js/app/contexts/SessionContext';

/**
 * Returns the healthcare_entity id to use as a query filter for staff users
 * who are acting as a specific organization.
 *
 * - Staff with acting-as set: the chosen entity id
 * - Staff with no acting-as: undefined (callers should typically have a
 *   soft-prompt before reaching this point so this state is rare)
 * - HCO rep / provider: undefined — backend SecurityContextMixin scopes
 *   results from the security context, so no explicit filter is needed
 *
 * Use this when listing org-scoped resources (facilities, contacts, etc.)
 * from a context where the staff user's intended scope is the acting-as
 * organization. For *editing* an existing record, prefer the record's own
 * healthcare_entity id over this — staff may be acting-as Org B while
 * editing a record from Org A.
 */
export function useStaffOrgFilter(): string | undefined {
  const { audienceIsStaff, actingAsEntity } = useSessionContext();
  return audienceIsStaff ? (actingAsEntity?.id ?? undefined) : undefined;
}
